import{__require as r}from"./global-this.js";var e,t;function i(){if(t)return e;t=1;var i=r().navigator,a=i&&i.userAgent;return e=a?String(a):""}export{i as __require};
//# sourceMappingURL=environment-user-agent.js.map
